import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterBlog, sortBlog } from "../../features/filter/filterSlice";

export default function SideBar() {
  const { filter, sort } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  const handlefilter = (e) => {
    const inputValue = e.target.value;
    dispatch(filterBlog(inputValue));
  };
  const handleSort = (e) => {
    const sortValue = e.target.value;
    dispatch(sortBlog(sortValue));
  };

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            name="sort"
            id="lws-sort"
            value={sort}
            onChange={handleSort}
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
          >
            <option value="">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            <div>
              <input
                type="radio"
                name="filter"
                value={"all"}
                id="lws-all"
                className="radio"
                checked={filter === "all"}
                onChange={handlefilter}
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                value={"saved"}
                checked={filter === "saved"}
                onChange={handlefilter}
                name="filter"
                id="lws-saved"
                className="radio"
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
